import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngxs/store';
import { fetchAuthSession } from 'aws-amplify/auth';
import { Observable, from, throwError } from 'rxjs';
import { catchError, finalize, flatMap, mergeMap } from 'rxjs/operators';

import { AppProgressBarService } from './app-progressbar.service';
import { AuthAction } from './auth/store';

@Injectable()
export class TokenHttpinterceptor implements HttpInterceptor {
    constructor(
        private store: Store,
        private progressBarService: AppProgressBarService,
        private snackBar: MatSnackBar
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return this.handleAccess(request, next);
    }

    private handleAccess(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.progressBarService.set(true);
        if (!request.url.includes('organization-types')) {
            return from(
                fetchAuthSession()
                    .then((session) => {
                        return session?.tokens?.accessToken?.toString() || null;
                    })
                    .catch((err) => {
                        this.progressBarService.set(false);
                        return null;
                    })
            ).pipe(
                mergeMap((token) => {
                    let changedRequest = request;
                    if (token) {
                        const headerSettings: {
                            [name: string]: string | string[];
                        } = {};
                        for (const key of request.headers.keys()) {
                            headerSettings[key] = request.headers.getAll(key);
                        }
                        headerSettings['Authorization'] = 'Bearer ' + token;
                        const newHeader = new HttpHeaders(headerSettings);
                        changedRequest = request.clone({
                            headers: newHeader,
                        });
                    }
                    return next.handle(changedRequest).pipe(
                        finalize(() => {
                            this.progressBarService.set(false);
                        })
                    );
                }),
                catchError((error) => {
                    if (error?.error?.message === 'Access Token has been revoked') {
                        this.snackBar.open('Session expired, please log in again');
                        this.store.dispatch(new AuthAction.PinLogout());
                    }
                    return throwError(error);
                })
            );
        }
        return next.handle(request).pipe(
            finalize(() => {
                this.progressBarService.set(false);
            })
        );
    }
}
